import { useMemo, useState } from "react";
import { useTable } from "react-table";
import { defaultDateDisplay } from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import { pathConstants } from "../../../routes/pathContants";
import { Link, useNavigate } from "react-router-dom";
import Images from "../../../assets/images";

const useWaybillsTable = ({ waybills }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        Header: "Waybill No & Date",
        accessor: "id",
        Cell: ({ cell: { value }, row }) => (
          <span>
            <Link
              className="smallest-text-size purple--text"
              to={pathConstants.PROCUREMENT_VIEW_WAYBILL({
                id: value,
              })}
            >
              {value}
            </Link>
            <span className="d-block">
              {defaultDateDisplay(row?.original?.created_at)}
            </span>
          </span>
        ),
      },
      {
        Header: "Order ID",
        accessor: "order",
        Cell: ({ cell: { value } }) =>
          value ? (
            <span
              className="purple--text cursor-pointer"
              onClick={() => {
                setSelectedOrder(value?.id);
              }}
            >
              {value?.id}
            </span>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Customer",
        accessor: "customer",
        Cell: ({ cell: { value }, row }) =>
          value ? (
            <Link
              className="smallest-text-size purple--text"
              to={pathConstants.CUSTOMER_DETAILS({
                customerId: value,
              })}
            >
              <span>{row?.original?.order?.customer?.full_name}</span>
            </Link>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Driver Name",
        accessor: "logistics",
        Cell: ({ cell: { value } }) => (
          <span className="text-muted">{value?.driver_name || "N/A"}</span>
        ),
      },
      {
        Header: "Logistics Company",
        accessor: "",
        Cell: ({ cell: { value }, row }) => (
          <span className="text-muted">
            {row?.original?.logistics?.company || "N/A"}
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "",
        Cell: ({ cell: { value }, row }) => (
          <span className="text-muted">
            {row?.original?.order?.store?.name || "N/A"}
          </span>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ cell: { value }, row }) => (
          <div className="d-flex" style={{ gap: "10px" }}>
            <primaryComponents.Button
              onClick={() =>
                navigate(
                  pathConstants.PROCUREMENT_VIEW_WAYBILL({
                    id: row?.original?.id,
                  }),
                )
              }
              classNames={"btn btn--primary smallBtn"}
            >
              View
            </primaryComponents.Button>
            <primaryComponents.Button
              onClick={() =>
                window.open(
                  row?.original?.waybill_url,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              classNames={"btn btn--outline smallBtn"}
              isDisabled={!row?.original?.waybill_url}
            >
              <img width={18} src={Images.waybills} alt="" className="mr-1" />
            </primaryComponents.Button>
          </div>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns: columns,
    data: waybills,
  });

  return {
    instance,
    selectedOrder,
    setSelectedOrder,
  };
};

export default useWaybillsTable;
